import cx from 'classnames';
import { Form } from 'react-bootstrap';
import { useFormContext, useFormState } from 'react-hook-form';
import { ButtonListController } from '../../components/hookForm/ButtonListController';
import { SelectController } from '../../components/hookForm/SelectController';
import { NAME_EXCLUDED_SPECIAL_CHARS } from '../../constants/validationConstants';
import { reactSelectStyles } from '../../helpers/reactSelectStyles';
import styles from './EditForm.module.scss';

export const FIELD_TYPE = {
  BUTTONS_LIST: 'buttonList',
  SELECT: 'select',
}

export const EditForm = ({
  fields,
  disabled,
  layout,
}) => {
  const oneliner = layout === 'oneliner';
  const { register, control, setValue } = useFormContext();
  const { errors } = useFormState({
    control
  });

  return (
    <div className={cx(styles.form, oneliner && styles.oneliner)}>
      {fields?.map((field) => {

        const validate = field.validate;
        const fieldRegister = register(field.name);
        const handleChange = (e) => {
          e.preventDefault();
          const value = e.target.value;

          if (validate && !validate(value)) {
            setValue('name', value.replace(NAME_EXCLUDED_SPECIAL_CHARS, ''));
            return;
          }

          fieldRegister.onChange(e);
        }

        if (field.Component) {
          return (
            <div key={field.name}>
              {field.Component({ control, setValue })}
            </div>
          );
        }

        if (field.hidden) return null;

        if (field.type === 'select') {

          return (
            <SelectController
              key={field.name}
              name={field.name}
              control={control}
              selectStyles={reactSelectStyles}
              isClearable={false}
              placeholder={field.placeholder}
              containerClassName={styles.fieldContainer}
              isDisabled={disabled}
              {...field.selectProps}
            />
          );
        }

        if (field.type === 'buttonList') {
          return (
            <ButtonListController 
              key={field.name}
              name={field.name}
              control={control}
              options={field.options}
            />
          )
        }

        return (
          <Form.Group className={styles.fieldContainer} controlId="formGroupEmail" key={field.name}>
            <Form.Control
              type="text"
              // {...register(field.name)}
              placeholder={field.placeholder}
              className={`form-control ${errors[field.name] ? 'is-invalid' : ''}`}
              disabled={disabled}
              {...fieldRegister}
              onChange={validate ? handleChange : fieldRegister.onChange}
            />
            <div className="invalid-feedback">{errors[field.name]?.message}</div>
          </Form.Group>
        );
      })}
    </div>
  );
};